import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { contentStyles, h5, paragraphSmall } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.article `
  --borderRadius: 10px;
  --bgColor: ${brand.primary.blueGrey};
  --fgColor: ${brand.primary.blue};

  display: grid;
  grid-template-rows: auto 1fr;
  border-radius: var(--borderRadius);
  height: 100%;
`;
const ImageWrapper = styled.div `
  aspect-ratio: 576 / 353;
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 10px 10px 0 0;

  [data-image-shape='curved'] & {
    aspect-ratio: 576 / 427;
    border-radius: 1000000px 1000000px 0 0;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled.div `
  color: var(--fgColor);
  background-color: var(--bgColor);
  padding: ${fluid(16, 40)} ${fluid(16, 30)};
  border-radius: 0 0 var(--borderRadius) var(--borderRadius);
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(22, 26)};
    margin: auto auto 8px;

    @media ${from(Device.Tablet)} {
      margin-bottom: 0;
    }
  }
`;
const ContentArea = styled.div `
  flex: 1 0 auto;
  padding-bottom: 10px;

  > :last-child {
    margin-bottom: 0;
  }
`;
const TagArea = styled.div ``;
const Tag = styled.span `
  ${paragraphSmall};
  ${fonts.lato.medium};

  background-color: var(--tagColor);
  color: var(--tagFgColor);
  padding: 4px 15px;
  border-radius: calc(var(--borderRadius) / 2);
  margin-bottom: 20px;
`;
const Title = styled.h3 `
  ${h5}
  margin-bottom: 26px;
`;
const Content = styled.div `
  ${contentStyles};

  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 0 16px;

  p {
    ${paragraphSmall}
  }

  a {
    color: ${brand.primary.orange};
  }
`;
const CtaArea = styled.div `
  ${CtaLinkStyles.Container}[data-has-arrow='false'] {
    svg {
      path.external-link_svg__arrow {
        ${transition('transform')};
      }
    }

    &:focus,
    &:hover {
      svg {
        path.external-link_svg__arrow {
          transform: translate(5px, -5px);
        }
      }
    }
  }
`;
const CtaCardStyles = {
    Container,
    ContentArea,
    ContentWrapper,
    Content,
    CtaArea,
    Img,
    ImageWrapper,
    Tag,
    TagArea,
    Title,
};
export default CtaCardStyles;
